import { EditVehicleCategoryPanel } from "@/components/organisms";

export const VehicleCategoriesEdit = () => {
  return <EditVehicleCategoryPanel />;
};
